import { useParams } from "react-router";
import HeaderBackNav from "../../components/header-back-navigation/HeaderBackNav";
import {
  AppointmentMainIcon,
  CheckGreen,
  InfoIcon,
  RequestChnages,
  RequestHistoryView,
  UserIcon,
} from "../../assets/common-svg/CommonSvg";
import CustomAccordion from "../../components/custom-accordion/CustomAccordion";
import { useEffect, useState } from "react";
import { FormView } from "../form-template/create-form-template/FormView";
import CustomDrawer from "../../components/custom-drawer/CustomDrawer";
import { FormCommentList } from "../../components/form-template/FormCommentList";
import { FormValues } from "../../components/form-template/FormValues";
import { CustomHeaderCard } from "../../components/custom-header-card/CustomHeaderCard";
import { getUserHasAccess } from "../../utils/authorities";
import { Button, Chip, Grid, Tooltip, Typography } from "@mui/material";
import SkeletonLoader from "../../utilites/SkeltonLoader";
import SubjectApi from "../../services/subjectService";
import { useDispatch, useSelector } from "react-redux";
import { setSnackbar } from "../../store/reducers/snackBar";
import {
  UrlToRouteArrayConverter,
  calculateYears,
} from "../../utilites/Common";
import { CustomSnackbar } from "../../components/snackbar/CustomSnackbar";
import NoDataCard from "../../components/no-data-card";
import moment from "moment";
import SelectFormModel from "../../components/custom-model/SelectFormModel";
import QueryApi from "../../services/queryManage";
import BreadCrumb from "../breadcrumb/BreadCrumb";
import CustomDropdown from "../../components/custom-dropdown/CustomDropdown";
import ConfirmationModal from "../../components/modal-contents/ConfirmationModal";
import { GenderList, StatusChangeHeading } from "../../utils/common";
import CustomModel from "../../components/custom-model/CustomModel";
import {
  deadDateValue,
  EditSubjectPhase,
  FollowUpLostDateValue,
  patientIdValue,
  requestChangeInitial,
} from "../../utils/formik/initialValues";
import {
  addPatientIdSchema,
  deathDateSchema,
  editSubjectPhaseValidationSchema,
  lostToFollowUpSchema,
  recordedDateSchema,
  requestModalDataSchema,
} from "../../utils/formik/validationSchema";
import SubAdminApi from "../../services/subAdminService";
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
// import { upperCase } from "lodash";

export const AppointmentDetails = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [deadValue, setDeadValue] = useState(deadDateValue)
  const [followUpValue, setFollowUpValue] = useState(FollowUpLostDateValue)
  const [lifeStatusValue, setLifeStatusValue] = useState('')
  const LoginData = useSelector((state) => state.loginData);
  const userAuthority = LoginData?.auth || [];
  const role_id = LoginData?.role_id
  const snackbar = useSelector((state) => state.snackBar);
  const AssignedFormDataList = useSelector(
    (state) => state?.phaseReducer.asignedFormTemplate
  );
  const [recordedDateModel, setRecordedDateModel] = useState(false);
  const [recordedDate, setRecordedDate] = useState(null);
  const phaseDetails = useSelector((state) => state?.phaseReducer?.phaseDetail);
  const [SubjectData, setSubjectData] = useState({});
  const [lifeValue, setLifeValue] = useState("");
  const [selectedLifeValue, setSelectedLifeValue] = useState("");
  const [requestReasonMenu, setRequestReasonMenu] = useState([])
  const [recordCurrentInfo, setRecordCurrentInfo] = useState([])
  const [isRequestChangeModal, setIsRequestChangeModal] = useState(false);
  const [patientId, setPatientId] = useState(""); // This would be removed when setting from api.
  const [openDateModal, setOpenDateModal] = useState(false);
  const [openAddPatientIdModal, setOpenAddPatientIdModal] = useState(false);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [breadCrumbArray] = useState(
    UrlToRouteArrayConverter(phaseDetails, location.pathname)
  );
  const [queryLoading, setQueryLoading] = useState(false);
  const [openAppointmentModel, setOpenAppointmentModel] = useState(false);
  const [isFormLoading, SetIsFormLoading] = useState(false);
  const [accordionData, setAccordionData] = useState([]);
  const [openConfirmStausChange, setOpenConfirmStausChange] = useState(false);
  const [openConfirmChangesApplied, setOpenConfirmChangesApplied] = useState(false);
  const [confimationTitle, setConfimationTitle]=useState('')
  const [changeAppliedId, setChangeAppliedId]=useState('')
  const [formTemplateList, setFormTemplateList] = useState([]);
  const [historyOpen, setHistoryOpen] = useState(false);
  const [historyData,setHistoryData]=useState([])
  const [editPatientModelOpen, setEditPatientModelOpen] = useState(false)
  const [editSubjectPatient, setEditSubjectPatient] = useState(EditSubjectPhase)
  const [editPatientModelData, setEditPatientModelData] = useState({
    title: "Edit Patient",
    editTitle: "Edit Patient",
    children:
      [
        {
          type: "input",
          name: "first_name",
          label: "First Name",
          placeholder: "Enter First Name",
          IsRequired: true,
        },
        {
          type: "input",
          name: "last_name",
          label: "Last Name",
          placeholder: "Enter Last Name",
          IsRequired: true,
        },
        {
          type: "dropdown",
          name: "gender",
          label: "Gender",
          placeholder: "Select gender",
          data: [],
          IsRequired: true,
        },
        {
          type: "input",
          name: "investigator_id",
          label: "Principal Investigator",
          placeholder: "Select principal investigator",
          data: [],
          IsRequired: true,
          disabled: true,
        },
        {
          type: "input",
          name: "editor_id",
          label: "Editor",
          placeholder: "Select Editor",
          data: [],
          IsRequired: true,
          disabled: true,
        },
        {
          type: "input",
          name: "disease_id",
          label: "Disease",
          placeholder: "Select disease",
          data: [],
          IsRequired: true,
          disabled: true,
        },
        {
          type: "date",
          name: "dob",
          label: "Date of Birth",
          placeholder: "Select Date",
          minDate: false,
          maxDate: new Date(),
          IsRequired: true,
        }
      ]

  });
// const [previousObject,setPreviousObject]=useState({})


  const [queryData, setQueryData] = useState([
    {
      title: "Relapsed/Refractory",
      leftBorder: false,
      backgroundColor: "#F0F1F5",
      color: "#000000",
      expanded: false,
      menuData: [
        {
          title: "Aman Sharma Max Hospital (PI)",
          name: "AS",
          describe: "Is sugar test done empty stomach ?",
          date: "05/04/2024",
        },
      ],
      previous_value: [],
    },
  ]);

  const [dateModelData, setDateModelData] = useState({
    title: "Add Date",
    children: [],
  });

  const [requestModalData, setRequestModalData] = useState({
    title: "Request To Update",
    children: [],
  });

  const [addIdModelData] = useState({
    title: "Add Patient Id",
    children: [
      {
        type: "input",
        name: "patientId",
        label:
          "Ensure that the entered Patient ID is same as received from ImmunoACT",
        placeholder: "Enter Patient Id",
        IsRequired: true,
      },
    ],
  });

  const getSubjectDetails = async () => {
    try {
      const res = await SubjectApi.getSubjectDetails(id);
      setSubjectData(res?.data);
      setLifeValue(
        res?.data?.life_status?.toLowerCase() == "lost"
          ? "lost_to_follow_up"
          : res?.data?.life_status?.toLowerCase() || ""
      );
      setPatientId(res?.data?.patient_id);
      let accData = [];
      res?.data?.appointment_details?.map((op) => {
        let obj = {};
        obj.title = op?.title;
        if (
          op?.appointment_answer?.appointment_answer_status == "in-progress"
        ) {
          obj.status = [
            {
              icon: <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />,
              text: "In Progress",
              color: "#FB9D2C",
            },
          ];
          obj.color = "#FB9D2C";
        } else if (
          op?.appointment_answer?.appointment_answer_status == "completed"
        ) {
          obj.status = [
            {
              icon: <CheckGreen Filled="#00B278" />,
              text: "Completed",
              color: "#00B278",
            },
          ];
          obj.color = "#00B278";
        } else {
          obj.status = [
            {
              icon: <InfoIcon Height={20} Width={20} Filled="#FB9D2C" />,
              text: "In Progress",
              color: "#FB9D2C",
            },
          ];
          obj.color = "#FB9D2C";
        }
        if (op?.appointment_answer?.type) {
          obj.type = op?.appointment_answer?.type;
        }
        if (op?.totalQueryCount > 0) {
          obj.status = [
            ...obj.status,
            {
              icon: (
                <div className="border-l-2 ">
                  <Typography
                    variant="body1"
                    className="ml-2 rounded-3xl text-center align-self-center  text-[0.8rem] w-[1.2rem] h-[1.2rem] text-white bg-[#FF0000]"
                  >
                    {op?.totalQueryCount}
                  </Typography>
                </div>
              ),
              text: "Query Raised",
              color: "#FF0000",
            },
          ];
        }
        obj.appointment_answer_id = op?.appointment_answer?.id;
        obj.appointment_id = op?.id;
        obj.query = 3;
        obj.leftBorder = true;
        obj.expanded = false;
        accData.push(obj);
      });
      setAccordionData(accData);
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    } finally {
      setLoading(false);
    }
  };




  const handleExpansion = (index) => {
    let s1 = [...accordionData];
    if (s1[index] && s1[index].expanded !== undefined) {
      s1[index].expanded = !s1[index].expanded;
    }
    setAccordionData(s1);
  };

  const getQueryHistory = async (id, version) => {
    setQueryLoading(true);
    try {
      const res = await QueryApi.getAllQueryHistory(id, version);
       if (res?.data && res?.data.length != 0) {
        let data = res?.data.map((op) => {
          return {
            title: op.field_name,
            leftBorder: false,
            backgroundColor: "#F0F1F5",
            color: "#000000",
            expanded: false,
            menuData: op.appointment_queries_replies.map((op) => {
              return {
                title: `${op.user_name} (${op.role})`,
                name: `${op.user_name[0]}${op.user_name[1]}`,
                describe: op.query,
                date: op.created_at,
              };
            }),
            values: {
              previous_value: op.previous_answer_value,
              new_value: op.new_answer_value,
            },
          };
        });
        toggleDrawer();
        // setDrawerTitle("");
        setQueryData(data);
      } else {
        setQueryData([]);
        dispatch(
          setSnackbar({ value: true, message: res?.message, color: "error" })
        );
      }
    } catch (error) {
      console.log(error);
    } finally {
      setQueryLoading(false);
    }
  };

  const handleChangeForm = (data, index, name) => {
    let s1 = [...accordionData];
    s1[index][name] = data;
    setAccordionData(s1);
  };

  const handleAddAppointmentModel = async (values) => {
    SetIsFormLoading(true); // Reset loading state
    setRecordedDateModel(true);
    setRecordedDate({ ...values, last_recorded_visit_date: "" });
    setDateModelData((prev) => ({
      ...prev,
      title: "Add Date",
      children: [
        {
          type: "date",
          name: "last_recorded_visit_date",
          label: "Last Recorded Visit Date",
          placeholder: "Select Date",
          minDate: false,
          maxDate: new Date(),
          IsRequired: true,
        },
      ],
    }));
    setOpenAppointmentModel(false);
    SetIsFormLoading(false); // Reset loading state
  };

  const handleRecordingDate = async (data) => {
    setButtonLoading(true);
    let updatedValues = {
      title: data.form.title,
      form_template_id: data.form.id || 0,
      phase_id: SubjectData.phase_id,
      subject_id: SubjectData.id,
      last_recorded_visit_date: data.last_recorded_visit_date,
    };

    try {
      // API call to add phase
      const response = await SubjectApi.addAppointment(updatedValues);

      await getSubjectDetails();
      // window.location.reload();
      // Dispatch success snackbar message
      dispatch(
        setSnackbar({
          value: true,
          message: response.message || "Appointment added successfully",
          color: "success",
        })
      );
    } catch (error) {
      dispatch(
        setSnackbar({
          value: true,
          message: error?.message || error || "Failed to add appointment",
          color: "error",
        })
      );
    } finally {
      setButtonLoading(false);
      setRecordedDateModel(false); // Reset loading state
    }
  }

  
  const toggleDrawer = () => {
    setOpen(!open);
  };

 // Handle the toggleDrawer for the history viewer:
 const handleHistoryDrawer = () => {
  // setHistoryOpen(!historyOpen);
  handleGetHistoryData();
};

// let PrviousVal;
const handleGetHistoryData = async () => {
  const payload = {
    subject_id: SubjectData.id,
    phase_id: SubjectData.phase_id,
    page: 1,
    limit: 10,
  };
  try {
    const response = await SubjectApi.requestHistory(
      payload.limit,
      payload.page,
      payload.phase_id,
      payload.subject_id
    );
    if(response.data.length>0){
      setHistoryOpen(!historyOpen)
      setHistoryData(response.data);
    }else{
      dispatch(
        setSnackbar({
          value: true,
          message:response.message,
          color: "error",
        })
      );
    }
  } catch (error) {
    dispatch(
      setSnackbar({
        value: true,
        message: error?.message || error || "Failed to add appointment",
        color: "error",
      })
    );
}
}

  const handleRequestApproval = async (id) => {
    setChangeAppliedId(id)
    const payload = { request_reason_id: id };
    try {
      const response = await SubjectApi.requestApproval(
        payload
      );
      if(response.status==200){
        handleGetHistoryData();
        setHistoryOpen(open)
        dispatch(
          setSnackbar({
            value: true,
            message: response.message,
            color: "success",
          })
        );
      }
      if (response.confirm) {
        setConfimationTitle(response.message)
        setOpenConfirmChangesApplied(true)
      }
    } catch (error) {
      dispatch(
        setSnackbar({
          value: true,
          message: error?.message || error || "Failed to add appointment",
          color: "error",
        })
      );
    }
  };


  // handle the confirmation Chnages Applied 
  const handleConfirmationChnagesApplied = async (confirmationResult) => {
    if (confirmationResult) {
      const payload = {
        request_reason_id: changeAppliedId,
        confirm: true
      };
      try {
        const response = await SubjectApi.requestApproval(
          payload
        );
        handleGetHistoryData();
        setHistoryOpen(open)
        if (response.status == 200) {
          dispatch(
            setSnackbar({
              value: true,
              message: response.message,
              color: "success",
            })
          );
        }
      } catch (error) {
        dispatch(
          setSnackbar({
            value: true,
            message: error?.message || error || "Failed to add appointment",
            color: "error",
          })
        );
      }
      finally{
        setOpenConfirmChangesApplied(false)
      }
    }
    //  else {
    //   console.log("No Choosed")
    // }
  }

  const handleQuery = (index) => {
    let s1 = [...queryData];
    if (s1[index] && s1[index].expanded !== undefined) {
      s1[index].expanded = !s1[index].expanded;
    }
    setQueryData(s1);
  };

  const findFormTypeID = (form_template_id) =>
    AssignedFormDataList?.find(
      (item) => Number(item.type.id) === Number(form_template_id)
    )?.id;

  const handleAddAppointment = async () => {
    try {
      const res = await SubAdminApi?.formTemplateOrderwise({
        subject_id: SubjectData.id,
        phase_id: SubjectData.phase_id,
      });

      if (res?.data?.length > 0) {
        const dataUpdated =
          res?.data?.map((item) => ({
            id: item?.form_template_id || findFormTypeID(item?.id),
            title: item?.name,
          })) || [];
        setFormTemplateList(dataUpdated);
        setOpenAppointmentModel(true);
      } else {
        dispatch(
          setSnackbar({
            value: true,
            message: "Required numbers of visits have been recorded",
            color: "error",
          })
        );
      }
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  const handleSelectFormError = (error) => {
    dispatch(
      setSnackbar({
        value: true,
        message: error,
        color: "error",
      })
    );
  };

  const patientLifeMenu = [
    { id: "alive", name: "Alive" },
    { id: "dead", name: "Dead" },
    { id: "lost_to_follow_up", name: "Lost to Follow Up" },
  ];

  const handlePatientLife = async (data) => {
    setButtonLoading(true);
    let statusChangeDate =
      selectedLifeValue == "dead"
        ? moment(data?.deathDateValue).format("DD/MM/YYYY")
        : moment(data?.lostToFollowUp).format("DD/MM/YYYY");
    try {
      let payload = selectedLifeValue == "alive" || !data
        ? {
          subject_id: SubjectData?.id,
          life_status: 'alive',
        } : {
          subject_id: SubjectData?.id,
          life_status: selectedLifeValue == "dead" ? selectedLifeValue : "lost",
          status_change_date: statusChangeDate,
          description: data.description ? data.description : ''
        }
      const res = await SubjectApi.changeLifeStatus(payload);
      if (res.status) {
        getSubjectDetails();
        dispatch(
          setSnackbar({ value: true, message: res?.message, color: "success" })
        );
      } else {
        dispatch(
          setSnackbar({
            value: true,
            message: res?.message,
            color: "error",
          })
        );
      }
    } catch (error) {
      console.error("Error changing life status:", error);
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    } finally {
      setButtonLoading(false);
      setOpenDateModal(false);
      setDateModelData((prev) => ({ ...prev, children: [] }));
    }
  };

  const handleAddPatientId = async (data) => {
    setButtonLoading(true);
    try {
      const res = await SubjectApi.addPatientId({
        subject_id: SubjectData?.id,
        patient_id: data?.patientId,
      });
      if (res.status) {
        getSubjectDetails();
        dispatch(
          setSnackbar({
            value: true,
            message: res.message,
            color: "success",
          })
        );
      }
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    } finally {
      setOpenAddPatientIdModal(false);
      setButtonLoading(false);
    }
  };

  const toggleDateModal = () => {
    setOpenDateModal(true);
  };

  const handleStatusChangeConfirmation = (confirmationResult) => {
    if (confirmationResult) {
      setOpenConfirmStausChange(false);
      if (lifeStatusValue !== 'alive') {
        toggleDateModal();
      } else {
        handlePatientLife()
      }
    } else {
      setOpenConfirmStausChange(false);
      setSelectedLifeValue(""); // selected value to be empty when No button is clicked
      setDateModelData((prev) => ({ ...prev, children: [] })); //SetModal Children to be empty
      //Repeat the same above when api process is completed  either in response/error encounter.
    }
  };

  const handleOpenConfirmModal = (value, confirmModel) => {
    setLifeStatusValue(value);
    confirmModel
      ? setOpenConfirmStausChange(true)
      : value != "alive"
      ? toggleDateModal()
      : "";
    setSelectedLifeValue(value);
    if (value == "dead") {
      if (!confirmModel) {
        setDeadValue({
          deathDateValue: moment(
            SubjectData.status_change_date,
            "DD/MM/YYYY"
          ).format("MM/DD/YYYY"),
        });
      }
      setDateModelData((prev) => ({
        ...prev,
        title: confirmModel ? "Add Date" : "Edit Date",
        children: [
          {
            type: "date",
            name: "deathDateValue",
            label: "Date of Death",
            placeholder: "Select Date",
            minDate: false,
            maxDate: new Date(),
            IsRequired: true,
          },
          {
            type: "input",
            name: "description",
            label: "Enter Description",
            placeholder: "Enter Description",
            IsRequired: true,
          },
        ],
      }));
    } else if (value == "lost_to_follow_up") {
      if (!confirmModel) {
        setFollowUpValue({
          lostToFollowUp: moment(
            SubjectData.status_change_date,
            "DD/MM/YYYY"
          ).format("MM/DD/YYYY"),
        });
      }
      setDateModelData((prev) => ({
        ...prev,
        title: confirmModel ? "Add Date" : "Edit Date",
        children: [
          {
            type: "date",
            name: "lostToFollowUp",
            label: "Date of Last Follow Up",
            placeholder: "Select Date",
            minDate: false,
            maxDate: new Date(),
            IsRequired: true,
          },
          {
            type: "input",
            name: "description",
            label: "Enter Description",
            placeholder: "Enter Description",
            IsRequired: false,
          },
        ],
      }));
    }
  };

  const handleStatusChange = (selectedValue) => {
    const reasonInfoDetail = recordCurrentInfo.data.find(
      (item) => item.id === selectedValue
    );
    let formatValue = reasonInfoDetail?.title?.toLowerCase().replace(" ", "_");
    if (reasonInfoDetail) {
      const updatedMenu = reasonInfoDetail.children.map((item) => ({
        id: item.id,
        name: item.title,
      }));
      setRequestModalData((prevState) => ({
        ...prevState,
        children: prevState.children.map((child) =>
          child.name === "Select_patient_Info_menu"
            // ? { ...child, data: updatedMenu, type: reasonInfoDetail.id == 11 ? "dropdown" : "multidropdown" }
            ? { ...child, data: updatedMenu, type: formatValue === 'demographics' ? "multidropdown" : "dropdown" }
            : child
        ),
      }));
    }
  };

   const handleOpenRequestModal = () => {
    getStatusDropDown();
    const filteredData = SubjectData?.life_status === 'alive'
      ? requestReasonMenu.filter((item) => item.name !== "Survival Status")
      : requestReasonMenu;
  
    setIsRequestChangeModal(true);
  
    setRequestModalData((prev) => ({
      ...prev,
      title: 'Request To Update',
      children: [
        {
          type: "dropdown",
          name: "Select_patient_request_status",
          label: "Select Patient's Request Reason",
          placeholder: "Select Patient's Request Status",
          IsRequired: true,
          data: filteredData,
        },
        {
          type: "dropdown",
          name: "Select_patient_Info_menu",
          label: "Select Patient's Info Reason",
          placeholder: "Select Patient's Info Reason",
          IsRequired: true,
          data: [],
        },
        {
          type: "description",
          name: "description",
          label: "Reason For Change",//@info update name of description to Reason for change
          placeholder: "Reason For Change",
          IsRequired: true,
        },
      ],
    }));
  };

  const handleRequestChangeSubmit = async (data) => {
    let convertPatientInfo = data.Select_patient_Info_menu.toString()
    try {
      let payload = {
        "change_request_reason_id": data.Select_patient_request_status,
        "change_request_reason_value_id": convertPatientInfo,
        "description": data.description,
        "subject_id": SubjectData.id,
        "phase_id": SubjectData.phase_id,
      }
      const res = await SubjectApi.requestChange(payload);
      if (res.status === 200) {
        dispatch(
          setSnackbar({ value: true, message: res?.message, color: "success" })
        );
        setIsRequestChangeModal(false)
      }
    } catch (error) {
      setIsRequestChangeModal(false);
      dispatch(
        setSnackbar({
          value: true,
          message: error[0].description,
          color: "error",
        })
      );
    }
  }
  // Function to get Reason Dropdown
  const getStatusDropDown = async () => {
    try {
      const res = await SubjectApi.getAllRequest();
      setRecordCurrentInfo(res);
      if (SubjectData?.life_status === 'alive') {
        const result = res.data
          .filter((item) => item.title !== "Survival Status")
          .map((item) => ({
            id: item.id,
            name: item.title,
          }));
        setRequestReasonMenu(result);
      } else {
        const result = res.data.map((item) => ({
          id: item.id,
          name: item.title,
        }));
        setRequestReasonMenu(result);
      }
    } catch (error) {
      dispatch(setSnackbar({ value: true, message: error, color: "error" }));
    }
  };

  const handleEditIcon = () => {
    let s1 = { ...editSubjectPatient }; // Shallow copy

    setEditPatientModelOpen(true);

    // Create a deep copy of SubjectData to avoid reference issues
    s1 = JSON.parse(JSON.stringify(SubjectData));

    s1.investigator_id = SubjectData?.investigator?.name;
    s1.editor_id = SubjectData?.editor?.name;
    s1.gender = SubjectData?.gender === "Male" ? 1 : SubjectData?.gender === "Female" ? 2 : 3;
    s1.disease_id = SubjectData?.disease?.name;

    setEditPatientModelData((prevState) => ({
      ...prevState,
      children: prevState.children.map((child) =>
        child.name === "gender" ? { ...child, data: GenderList } : child
      ),
    }));

    setEditSubjectPatient(s1); // Updating state with deep-copied and modified data
  };


  const handleEditPatient = async (values) => {
    try {
      const payload = {
        first_name: values?.first_name,
        last_name: values?.last_name,
        gender: GenderList.find(op => op.id == values.gender).name, // Use the awaited gender value
        dob: values?.dob,
        editor_id: values?.editor?.id,
        investigator_id: values?.investigator?.id,
        disease_id: values?.disease?.id,
        phase_id: values?.phase_id,
        phase_code: values?.phase_details?.phase_code,
        phase_title: values?.phase_details?.title,
      };
      const response = await SubjectApi.editPatient(payload, values?.id);
      dispatch(
        setSnackbar({
          value: true,
          message: response.message || "Patient Edited Successfully",
          color: "success",
        })
      );
      await getSubjectDetails();
    } catch (error) {
      dispatch(
        setSnackbar({
          value: true,
          message: error.message || error || "Failed to Edit Patient",
          color: "error",
        })
      );
    } finally {
      setEditPatientModelOpen(false)
    }
  }

  // Using to remove the underScore
  const handleRemoveUnderScore = (value) => {
    return value.split('_').join(' ');
  };
  
 
  useEffect(() => {
    setLoading(true);
    getSubjectDetails();
    getStatusDropDown();
    // handleGetHistoryData()
  }, [!accordionData && accordionData.length == 0, id]);

  return (
    <div className="p-3 flex flex-col gap-4 mt-4">
      <BreadCrumb BreadCrumbsListing={breadCrumbArray} />
      <SelectFormModel
        open={openAppointmentModel}
        setOpen={setOpenAppointmentModel}
        isFormLoading={isFormLoading}
        data={formTemplateList}
        SetIsFormLoading={SetIsFormLoading}
        handleValue={handleAddAppointmentModel}
        handleError={handleSelectFormError}
      />
      <div className="flex flex-col lg:grid grid-cols-12 gap-4 ">
        <div className="lg:col-start-1  lg:col-end-4 sm:col-start-1 sm:col-end-13 md:col-start-1 md:col-end-13 ">
          <CustomHeaderCard
            editIcon={true}
            handleEditIcon={handleEditIcon}
            SubjectData={{
              code: SubjectData?.subject_code,
              gender: SubjectData?.gender,
              age: calculateYears(SubjectData?.dob),
            }}
            DetailsArray={[
              { FieldName: "Patient Id", Value: patientId || "- -" },
              {
                FieldName: "Patient Status",
                icon: {
                  name: "Edit",
                  auth: 162,
                  value: lifeValue,
                  status:
                    lifeValue == "lost_to_follow_up" || lifeValue == "dead"
                      ? true
                      : false,
                  type: "edit",
                  toolText: "Edit the date",
                  event: handleOpenConfirmModal,
                },
                Value:
                  lifeValue == "lost_to_follow_up"
                    ? `Lost To Follow Up ${
                        SubjectData?.status_change_date
                          ? `(${SubjectData?.status_change_date})`
                          : ""
                      }`
                    : lifeValue == "dead"
                    ? `Dead ${
                        SubjectData?.status_change_date
                          ? `(${SubjectData?.status_change_date})`
                          : ""
                      }`
                    : lifeValue,
              },
              {
                FieldName: "Date of Birth",
                Value: moment(SubjectData?.dob).format("DD/MM/YYYY"),
              },
              {
                FieldName: "Phase",
                Value: `${SubjectData?.phase_details?.phase_code} ${SubjectData?.phase_details?.title}`,
              },
                {
                FieldName: "Added By",
                Value: SubjectData?.created_By?.name || "--"
              },
              {
                FieldName: "Editor",
                Value: SubjectData?.editor?.name || "Not Assigned",
              },      
              {
                FieldName: "Principal Investigator",
                Value: SubjectData?.investigator?.name || "Not Assigned",
              },
              {
                FieldName: "Hospital Name",
                Value:
                  SubjectData?.pi_coordinator?.hospital_details?.name ||
                  "Not Assigned",
              },
            ]}
            startIcon={<UserIcon />}
            endIcon={<AppointmentMainIcon />}
            loading={loading}
          />
        </div>
        <div className="lg:col-start-4 lg: col-end-13 sm:col-start-1 sm:col-end-13 ">
          <div>
            <div className="flex flex-col items-center  gap-3 md:gap-0 sm:flex-row  justify-content-between pb-3">
              <Typography variant="h5" className="align-self-center mt-4">
                Visit List
              </Typography>
              <div className=" w-[100%] sm:w-[100%] md:w-[88%] xl:w-[88%]">
                {loading ? (
                  <SkeletonLoader rowCount={1} height={30} isTable={false} />
                ) : (
                  <div className="flex gap-2  justify-content-end">
                    {getUserHasAccess(
                      userAuthority,
                      "appointmentManager",
                      125
                    ) && (
                      <Button
                        sx={{ height: "fit-content" }}
                        size="large"
                        className="align-self-end mr-2"
                        onClick={() => setOpenAddPatientIdModal(true)}
                        disabled={
                          SubjectData?.patient_id || lifeValue != "alive"
                        }
                      >
                        Add Patient Id
                      </Button>
                    )}
                    {getUserHasAccess(
                      userAuthority,
                      "appointmentManager",
                      126
                    ) && (
                      <CustomDropdown
                        DropDownlabel="Patient Life Status"
                        PlaceholderText={"Select Patient's Life Status"}
                        MenuList={patientLifeMenu}
                        handleChange={(e) =>
                          handleOpenConfirmModal(
                            e.target.value,
                            e.target.value == "alive" ? true : true
                          )
                        }
                        value={lifeValue}
                        PlaceholderTextMenu={true}
                        disabled={
                          role_id === 5
                            ? lifeValue == "alive"
                              ? false
                              : true
                            : false
                        } //@info Disable Life Status if not alive for editor
                        className={
                          lifeValue != "alive"
                            ? "cursor-not-allowed"
                            : "cursor-not-allowed"
                        }
                      />
                    )}

                    {getUserHasAccess(
                      userAuthority,
                      "appointmentManager",
                      122
                    ) && (
                      <Button
                        size="large"
                        className="align-self-end md:ml-2"
                        onClick={() => handleAddAppointment()}
                        disabled={
                          lifeValue !== "alive" || !SubjectData.isAddNewVisit
                        }
                        sx={{
                          cursor:
                            lifeValue === "alive" ? "pointer" : "not-allowed",
                          height: "fit-content",
                        }}
                      >
                        Add New Visit
                      </Button>
                    )}

                    {/* Adding here generic request only for editor*/}
                    {/* && lifeValue != "alive"  */}
                    {role_id === 5 ? (
                      <Tooltip
                        title={"Request Changes"}
                        onClick={() => handleOpenRequestModal()}
                      >
                        <button className="pt-4 cursor-pointer">
                          <RequestChnages />
                        </button>
                      </Tooltip>
                    ) : null}

                    {getUserHasAccess(
                      userAuthority,
                      "appointmentManager",
                      126
                    ) && (
                      <Tooltip
                        title={"Request History"}
                        onClick={() => handleHistoryDrawer()}
                      >
                        <button className="pt-4 cursor-pointer">
                          <RequestHistoryView />
                        </button>
                      </Tooltip>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="overflow-y-auto max-h-[534px]">
              {loading ? (
                <SkeletonLoader rowCount={5} height={80} isTable={false} />
              ) : accordionData.length == 0 && !loading ? (
                <div className="">
                  <NoDataCard borderRadius={"0.3rem"} />
                </div>
              ) : (
                accordionData?.map((acc, index) => (
                  <FormView
                    key={acc.appointment_id}
                    acc={acc}
                    index={index}
                    getQueryHistory={getQueryHistory}
                    handleChangeForm={handleChangeForm}
                    queryLoading={queryLoading}
                    handleExpansion={handleExpansion}
                    SubjectData={SubjectData}
                    patientLifeValue={lifeValue}
                  />
                ))
              )}
            </div>
          </div>
        </div>
      </div>
      <CustomDrawer open={open} toggleDrawer={toggleDrawer}>
        <div className="pl-4 pt-4 pr-4">
          <HeaderBackNav
            handleBackNav={toggleDrawer}
            TitleFontSize={"18px"}
            TitleFontWeight={700}
            Title={"Query History"}
          />
        </div>
        <hr />
        <div className="pl-4 pt-4 pr-4">
          {queryData?.length != 0 ? (
            queryData.map((query, index) => (
              <CustomAccordion
                key={index}
                accordionClassName={"w-[25rem] "}
                rootDivClass={"pb-3"}
                leftBorder={query?.leftBorder}
                index={index}
                expanded={query?.expanded}
                handleExpansion={handleQuery}
                color={query?.color}
                backgroundColor={query?.backgroundColor}
                title={query?.title}
              >
                <FormValues
                  leftLable={"Previous Value"}
                  leftValue={query?.values?.previous_value}
                  rightLable={"New Value"}
                  rightValue={query?.values?.new_value ?? "N/A"}
                />
                <hr className="pb-3" />
                <div>
                  <FormCommentList MenuData={query.menuData} />
                </div>
              </CustomAccordion>
            ))
          ) : (
            <div className="mt-4">
              <NoDataCard />
            </div>
          )}
        </div>
      </CustomDrawer>

     
      {/* Add Custom Drawer for the history viewer */}
      <CustomDrawer
        open={historyOpen}
        toggleDrawer={handleHistoryDrawer}
        className=""
      >
        <div className="pl-4 pt-4 pr-4 w-1/2">
          <HeaderBackNav
            handleBackNav={handleHistoryDrawer}
            TitleFontSize={"18px"}
            TitleFontWeight={700}
            Title={"Request History"}
          />
        </div>
        <hr />
        <div>
          {historyData?.map((item, index) => (
            <Timeline
              key={index}
              sx={{
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0,
                },
              }}
            >
              <TimelineItem>
                <TimelineSeparator>
                  <TimelineDot
                    color={item.status == 1 ? "success" : "warning"}
                  />
                  <TimelineConnector sx={{ bgcolor: "success" }} />
                </TimelineSeparator>
                <TimelineContent>
                  <Chip
                    size="small"
                    color={item.status == 1 ? "success" : "warning"}
                    label={
                      item.createdAt
                        ? moment(item.createdAt).format("DD/MM/YYYY")
                        : "--"
                    }
                  />
                  <div className="bg-gray-100 d-flex flex-column gap-1 p-4 rounded mt-3">
                    <div className="d-flex flex-column gap-0">
                      <Typography variant="h5" className="m-0 p-0">
                        {item.changeRequestReason.title}
                      </Typography>

                      <Typography
                        variant="body1"
                        sx={{ color: "text.disabled" }}
                        className="flex gap-2 align-items-center capitalize"
                      >
                        {item.change_request_reason_value
                          .map((res) => res.title)
                          .join(",")}{" "}
                      </Typography>
                    </div>

                    <Typography
                      variant="body1"
                      className="flex gap-2 align-items-center "
                    >
                      {item.description}
                    </Typography>

                    {/* Add Grid here */}
                    <Grid container spacing={4}>
                      <Grid item xs>
                        <div>
                          <Typography
                            variant="h6"
                            sx={{ color: "text.disabled" }}
                            className="flex gap-2 align-items-center"
                          >
                            Previous Value
                          </Typography>

                          {/* sx */}
                          {item.previous_value !==null ? (
                            <table border="1">
                              {/* <thead>
                                <tr>
                                  <th>Field : </th>
                                  <th>Value</th>
                                </tr>
                              </thead> */}
                              <tbody>
                                {Object?.entries(JSON.parse(item.previous_value)).map(
                                  ([key, value]) => (
                                    <tr key={key}>
                                      <td>
                                        <Typography
                                          sx={{
                                            color: "warning.main",
                                            textTransform: `${key==='dob'? 'uppercase': 'capitalize'}`,
                                          }}
                                          variant="body1"
                                          className={`flex gap-2 align-items-center `}
                                        >
                                          {/* {key}: */}
                                          {handleRemoveUnderScore(key)}:
                                        </Typography>
                                      </td>
                                      <td>
                                        <Typography
                                          sx={{ color: "warning.main" ,textTransform: "capitalize",}}
                                          variant="body1"
                                          className="flex gap-2 align-items-center"
                                        >
                                          {value}
                                        </Typography>
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          ) : (
                            "--"
                          )}
                          {/* <Typography
                            variant="body1"
                            sx={{ color: "warning.main" }}
                            className="flex gap-2 align-items-center"
                          >
                            {item.previous_value}
                          </Typography> */}
                        </div>
                      </Grid>
                      <Grid item xs>
                        <div>
                          <Typography
                            variant="h6"
                            sx={{ color: "text.disabled" }}
                            className="flex gap-2 align-items-center"
                          >
                            New Value
                          </Typography>
                          {item.updated_value !==null ? (
                            <table border="1">
                              {/* <thead>
                                <tr>
                                  <th>Key : </th>
                                  <th>Value</th>
                                </tr>
                              </thead> */}
                              <tbody>
                                {Object.entries(
                                  JSON.parse(item.updated_value)
                                ).map(([key, value]) => (
                                  <tr key={key}>
                                    <td>
                                      <Typography
                                        sx={{ color: "success.main" ,textTransform:`${key==='dob'? 'uppercase': 'capitalize'}`, }}
                                        variant="body1"
                                        className="flex gap-2 align-items-center"
                                      >
                                        {handleRemoveUnderScore(key)}:
                                      </Typography>
                                    </td>
                                    <td>
                                      <Typography
                                        sx={{ color: "success.main", textTransform: "capitalize", }}
                                        variant="body1"
                                        className="flex gap-2 align-items-center"
                                      >
                                        {value}
                                      </Typography>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          ) : (
                            "--"
                          )}
                          {/* <Typography
                            sx={{ color: "success.main" }}
                            variant="body1"
                            className="flex gap-2 align-items-center"
                          >
                            {item.updated_value ? item.updated_value : "--"}
                          </Typography> */}
                        </div>
                      </Grid>
                      <Grid item xs>
                        <div>
                          <Typography
                            variant="h6"
                            sx={{ color: "text.disabled" }}
                            className="flex gap-2 align-items-center"
                          >
                            Resolved By
                          </Typography>
                          <Typography
                            variant="body1"
                            className="flex gap-2 align-items-center"
                            sx={{ textTransform: "capitalize" }}
                          >
                            {item.resolver ? item?.resolver?.name : "--"}
                          </Typography>
                        </div>
                      </Grid>
                      <Grid item xs>
                        <div>
                          <Typography
                            variant="h6"
                            sx={{ color: "text.disabled" }}
                            className="flex gap-2 align-items-center"
                          >
                            Resolved Date
                          </Typography>
                          <Typography
                            variant="body1"
                            className="flex gap-2 align-items-center"
                          >
                            {item.resolver
                              ? moment(item.updatedAt).format("DD/MM/YYYY")
                              : "--"}
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                    {!item.updated_value && role_id === 1 ? ( //@info only visible to superAdmin and if value not update
                      <Button
                        sx={{ height: "fit-content" }}
                        size="large"
                        className="mr-2"
                        onClick={() => handleRequestApproval(item.id)}
                      >
                        Change Applied
                      </Button>
                    ) : null}
                  </div>
                </TimelineContent>
              </TimelineItem>
            </Timeline>
          ))}
        </div>
      </CustomDrawer>
      <CustomModel
        // modelData={isRequestChangeModal?requestModalData:  openAddPatientIdModal ? addIdModelData : dateModelData}
        modelData={
          isRequestChangeModal
            ? requestModalData
            : openAddPatientIdModal
            ? addIdModelData
            : dateModelData || {}
        }
        // open={openDateModal || openAddPatientIdModal || recordedDateModel || requestModalData}
        // setOpen={openDateModal ? setOpenDateModal : recordedDateModel ? setRecordedDateModel : requestModalData? setRequestModalData: setOpenAddPatientIdModal}
        open={Boolean(
          openDateModal ||
            openAddPatientIdModal ||
            recordedDateModel ||
            isRequestChangeModal
        )}
        setOpen={
          openDateModal
            ? setOpenDateModal
            : recordedDateModel
            ? setRecordedDateModel
            : isRequestChangeModal && requestModalData
            ? setIsRequestChangeModal
            : setOpenAddPatientIdModal
        }
        modalInitialValues={
          isRequestChangeModal && requestModalData
            ? requestChangeInitial
            : openDateModal
            ? selectedLifeValue == "dead"
              ? deadValue
              : followUpValue
            : recordedDateModel
            ? recordedDate
            : patientIdValue
        }
        initialValuesValidationSchema={
          isRequestChangeModal && requestModalData
            ? requestModalDataSchema
            : openDateModal
            ? selectedLifeValue == "dead"
              ? deathDateSchema
              : lostToFollowUpSchema
            : recordedDateModel
            ? recordedDateSchema
            : addPatientIdSchema
        }
        handleModelValues={
          isRequestChangeModal
            ? handleRequestChangeSubmit
            : openDateModal
            ? handlePatientLife
            : recordedDateModel
            ? handleRecordingDate
            : handleAddPatientId
        }
        resistOverFlow={(openDateModal || recordedDateModel) ?? false} // make it conditional only for date one
        isLoadingBtn={buttonLoading}
        onChange={(e) => handleStatusChange(e)}
      />
      <ConfirmationModal
        open={openConfirmStausChange?openConfirmStausChange:  openConfirmChangesApplied}
        setOpen={openConfirmStausChange? setOpenConfirmStausChange: setOpenConfirmChangesApplied}
        errMessage={openConfirmStausChange?StatusChangeHeading: confimationTitle}
        handleConfirmation={openConfirmStausChange? handleStatusChangeConfirmation : handleConfirmationChnagesApplied}
      />
      <CustomSnackbar
        open={snackbar?.value}
        setOpen={setSnackbar}
        color={snackbar?.color}
        message={snackbar?.message}
      />
      <CustomModel
        modelData={editPatientModelData}
        open={Boolean(editPatientModelOpen)}
        setOpen={setEditPatientModelOpen}
        modalInitialValues={editSubjectPatient}
        initialValuesValidationSchema={editSubjectPhaseValidationSchema}
        handleModelValues={handleEditPatient}
        resistOverFlow={false} // make it conditional only for date one
        // isLoadingBtn={buttonLoading}
      />
    </div>
  );
}